export default __webpack_public_path__ + "a2fc71ef4114762441fd73d810ff8a67.svg";